/*
============================================
CLUSTER A/B TEST: Better Trust Icons Below ATC
Target: .bottom-txt.items-center on product pages
============================================
*/
(function() {
  var TEST_ID = '6aa317aa-0266-4982-9fd9-a7e08036687a';
  var CONTROL_VARIANT_ID = 'cfaa10e6-cb78-41d9-b00e-032888044cb7';
  var TREATMENT_VARIANT_ID = '5fbe3a38-23a1-4736-8158-27ddddaec9a9';

  var TARGET_SELECTOR = '.bottom-txt.items-center';
  var STYLE_ID = 'cluster-trust-badges-test-style';
  var STORED_VARIANT_KEY = 'cluster_variant_' + TEST_ID;
  var VARIANT_RESOLVE_TIMEOUT_MS = 1800;
  var VARIANT_STORE_POLL_MAX_MS = 12000;
  var VARIANT_POLL_INTERVAL_MS = 200;

  var currentVariant = 'control';
  var variantLocked = false;
  var domReady = document.readyState !== 'loading';
  var originalContentMap = [];

  var TREATMENT_HTML = [
    '<div class="cluster-trust-badges">',
    '  <div class="cluster-trust-badge">',
    '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
    '    <span>Secure Payments</span>',
    '  </div>',
    '  <div class="cluster-trust-badge">',
    '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22V12"/><path d="m16 17 2 2 4-4"/><path d="M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753"/><path d="M3.29 7 12 12l8.71-5"/><path d="m7.5 4.27 8.997 5.148"/></svg>',
    '    <span>365-Day Returns</span>',
    '  </div>',
    '  <div class="cluster-trust-badge">',
    '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    '    <span>Free Shipping for Vicci+ Members</span>',
    '  </div>',
    '</div>'
  ].join('\n');

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function getStoredVariant() {
    try {
      var stored = window.sessionStorage.getItem(STORED_VARIANT_KEY);
      if (stored === 'control' || stored === 'treatment') return stored;
    } catch (error) {}
    return null;
  }

  function storeVariant(variant) {
    if (variant !== 'control' && variant !== 'treatment') return;
    try {
      window.sessionStorage.setItem(STORED_VARIANT_KEY, variant);
    } catch (error) {}
  }

  function ensureTreatmentStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.cluster-trust-badges {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  gap: 16px;',
      '  margin-bottom: 20px;',
      '  color: #000;',
      '  font-family: "Proxima Nova", sans-serif;',
      '  font-size: 14px;',
      '  font-weight: 500;',
      '  line-height: 1.3;',
      '  letter-spacing: 0.14px;',
      '}',
      '.cluster-trust-badge {',
      '  display: flex;',
      '  flex-direction: column;',
      '  align-items: center;',
      '  text-align: center;',
      '  gap: 4px;',
      '}',
      '.cluster-trust-badge svg {',
      '  flex-shrink: 0;',
      '  color: #090b1a;',
      '  width: 24px;',
      '  height: 24px;',
      '}',
      '@media (max-width: 767px) {',
      '  .cluster-trust-badges {',
      '    gap: 12px;',
      '    font-size: 13px;',
      '  }',
      '  .cluster-trust-badge svg {',
      '    width: 24px;',
      '    height: 24px;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function removeTreatmentStyles() {
    var style = document.getElementById(STYLE_ID);
    if (style) style.parentNode.removeChild(style);
  }

  function getTargetElements() {
    return document.querySelectorAll(TARGET_SELECTOR);
  }

  function rememberOriginalContent(el) {
    for (var i = 0; i < originalContentMap.length; i++) {
      if (originalContentMap[i].el === el) return;
    }
    originalContentMap.push({ el: el, html: el.innerHTML });
  }

  function applyTreatment() {
    ensureTreatmentStyles();
    var targets = getTargetElements();
    for (var i = 0; i < targets.length; i++) {
      rememberOriginalContent(targets[i]);
      targets[i].innerHTML = TREATMENT_HTML;
      targets[i].classList.add('cluster-trust-badges-applied');
    }
  }

  function revertTreatment() {
    removeTreatmentStyles();
    for (var i = 0; i < originalContentMap.length; i++) {
      var data = originalContentMap[i];
      data.el.innerHTML = data.html;
      data.el.classList.remove('cluster-trust-badges-applied');
    }
    originalContentMap = [];
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';

    if (currentVariant === 'treatment') {
      applyTreatment();
    } else {
      revertTreatment();
    }
  }

  function lockAndApplyVariant(variant) {
    if (variantLocked) return;
    variantLocked = true;
    applyVariant(variant);
  }

  function tryApplyWhenReady() {
    if (!domReady) return;
    var targets = getTargetElements();
    if (targets.length === 0) return;
    if (currentVariant === 'treatment') {
      applyTreatment();
    }
  }

  if (!domReady) {
    document.addEventListener('DOMContentLoaded', function() {
      domReady = true;
      tryApplyWhenReady();
    });
  }

  window.addEventListener('load', function() {
    tryApplyWhenReady();
  });

  function resolveVariantDeterministically() {
    var assignedVariant = getAssignedVariant();
    if (assignedVariant) {
      storeVariant(assignedVariant);
      lockAndApplyVariant(assignedVariant);
      return;
    }

    var storedVariant = getStoredVariant();
    if (storedVariant) {
      lockAndApplyVariant(storedVariant);
    }

    var startedAt = Date.now();
    var pollInterval = setInterval(function() {
      var liveAssignedVariant = getAssignedVariant();
      if (liveAssignedVariant) {
        storeVariant(liveAssignedVariant);
        if (!variantLocked) {
          lockAndApplyVariant(liveAssignedVariant);
        }
        clearInterval(pollInterval);
        return;
      }

      if (Date.now() - startedAt >= VARIANT_RESOLVE_TIMEOUT_MS) {
        if (!variantLocked) {
          lockAndApplyVariant('control');
        }
      }

      if (Date.now() - startedAt >= VARIANT_STORE_POLL_MAX_MS) {
        clearInterval(pollInterval);
      }
    }, VARIANT_POLL_INTERVAL_MS);
  }

  resolveVariantDeterministically();
})();
